<template>
  <div>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="row.orgName" :width="1000" @on-cancel="$emit('cancel')">
      <table class="QHtable" v-if="!$isblank(row)">
        <tr>
          <th style="width: 125px">单位信息</th>
          <th></th>
        </tr>
        <tr>
          <td style="width: 125px"><b>接收单位</b></td>
          <td>
            <span> {{ row.orgName }}</span>
          </td>
        </tr>
        <tr>
          <td style="width: 125px"><b>通讯地址</b></td>
          <td>{{ row.org.addressFull }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>联系姓名</b></td>
          <td>{{ row.org.contactName }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>联系电话</b></td>
          <td>{{ row.org.contactTel }}</td>
        </tr>
        <tr>
          <th style="width: 125px">接收权限</th>
          <th></th>
        </tr>
        <tr>
          <td style="width: 125px"><b>接收地址</b></td>
          <td>
            <span> {{ row.addressFull }}</span>
          </td>
        </tr>
        <tr>
          <td style="width: 125px"><b>接收许可</b></td>
          <td v-if="!$isblank(row.canUnloadCar)">
            <span v-if="row.canUnloadCar == 100">仅接收自己（只能接收自己单位司机卸车,不接收三方司机卸车）</span>
            <span v-if="row.canUnloadCar == 200">仅接收三方（只能接收三方单位司机卸车,不接收自己司机卸车）</span>
            <span v-if="row.canUnloadCar == 300">自己及三方（既可接收三方单位司机卸车,也可以自己司机卸车）</span>
          </td>
          <td v-else>
            <span>未设置接收许可,不可参与垃圾接收</span>
          </td>
        </tr>
        <tr>
          <td style="width: 125px"><b>电子围栏</b></td>
          <td>接收点坐标为中心方圆{{ row.authJuli }}米</td>
        </tr>
        <tr>
          <td><b>单位类型</b></td>
          <td>
            <span v-if="$commaToarr(row.compnayType).includes('100')">临时堆放</span>
            <span v-if="$commaToarr(row.compnayType).includes('200')">资源利用</span>
            <span v-if="$commaToarr(row.compnayType).includes('300')">分拣中心</span>
            <span v-if="$commaToarr(row.compnayType).includes('400')">工程回填</span>
            <span v-if="$commaToarr(row.compnayType).includes('500')">装卸码头</span>
            <span v-if="$commaToarr(row.compnayType).includes('600')">跨市处理</span>
            <span v-if="$commaToarr(row.compnayType).includes('700')">移动收集箱</span>
          </td>
        </tr>
        <tr>
          <td><b>处置方式</b></td>
          <td>{{ row.chuzhiWay }}</td>
        </tr>
        <tr>
          <td><b>工作时间</b></td>
          <td>{{ row.workTime }}</td>
        </tr>
        <tr>
          <td><b>开通时间</b></td>
          <td>{{ $timeFmt(row.created, "YYYY年MM月DD日 HH分mm秒") }} {{ row.from }}</td>
        </tr>
        <tr>
          <th style="width: 125px">相关资质</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in row.orgAllQualification" :key="index">
          <td>
            <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
          </td>
          <td>
            <div class="flex-between">
              <div>
                <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                <span class="MR5 CL5" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                <span>{{ item.name }}</span>
                <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
              </div>
              <div class="flex-between" style="margin-left: 10px">
                <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="$isblank(row.orgAllQualification)">
          <td style="text-align: center" colspan="10">暂未完善相关资质</td>
        </tr>
      </table>
    </Modal>
  </div>
</template>
<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      Checkbox: true,
      show: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:弹窗详情
    // +----------------------------------------------------------------------
    hiPop(e) {
      //参数整合与接口
      var that = this;
      var https = {
        type: "isRow",
        api: this.$api.getOrgjieshouDetailed,
        parameter: {
          id: e.id,
        },
      };
      this.$httpsApi(https, function (res) {
        that.title = res.data.name;
        that.show = true;
      });
    },
  },
};
</script>
